import { useLogRocket } from 'hooks/useLogRocket';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import LogRocketService from 'services/logRocketService';

const LogRocketInitializer = () => {
  const { isActive } = useLogRocket();
  const logRocketService = LogRocketService.getInstance();

  useEffect(() => {
    // Log detailed status
    const status = logRocketService.getStatus();
    console.log('🔍 LogRocket Status:', status);
    
    if (isActive) {
      console.log('✅ LogRocket is active and monitoring this session');
      
      // Expose test method globally for debugging
      (window as any).testLogRocket = () => logRocketService.testLogRocket();
      console.log('🧪 Test LogRocket with: window.testLogRocket()');
    } else {
      console.log('❌ LogRocket is disabled - no session monitoring');
    }
  }, [isActive]);

  return null; // This component doesn't render anything
};

export default observer(LogRocketInitializer);
